import {API} from '../config/config';

const OrderService = {
  save: (storeId, data) => saveOrder(storeId, data),
  getAll: (storeId, status, date, opts) => getAll(storeId, status, date, opts),
  getDashboard: (storeId, filters) => getDashboard(storeId, filters),
  searchOrders: (storeId, query) => searchOrders(storeId, query),
  updateStatus: (storeId, status, orders) => updateStatus(storeId, status, orders),
  updateLines: (storeId, orderId, linesPayload) => updateLines(storeId, orderId, linesPayload)
};

const withQuery = (path, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  const queryString = query.toString();
  return queryString ? `${path}?${queryString}` : path;
};

  const updateStatus = async (storeId, status, orders) => {
    try {
      var response = await API.post(`/stores/${storeId}/orders/changestatus?status=${status}`, orders)
      return response.data;
    } catch (err) {
      console.error('Error:', err);
      throw new Error(err)
    }
  }
  
  const getAll = async (storeId, status, date, opts = {}) => {
    try {
      // Normalize date to ISO date portion if it's a Date object
      let dateParam = date;
      if (date instanceof Date) {
        // send only yyyy-mm-dd to match backend expectations if any
        dateParam = date.toISOString().substring(0,10);
      }
      const omitDateForOpened = opts?.omitDateForOpened && (Array.isArray(status) ? status.includes('OPENED'): status === 'OPENED');
      let queryBase;
      if (omitDateForOpened) {
        queryBase = status === '' ? '' : `?status=${status}`;
      } else {
        queryBase = status === '' ? `?date=${dateParam}` : `?status=${status}&date=${dateParam}`;
      }
      console.log('[orders.getAll] fetching', queryBase || '(no-query)');
      let response = await API.get(`/stores/${storeId}/orders` + queryBase)
      let data = response.data;
      // Fallback: if opened and empty with date applied (when not omitting) attempt without date
      if (!omitDateForOpened && (Array.isArray(data) ? data.length === 0 : true) && (Array.isArray(status) ? status.includes('OPENED'): status === 'OPENED')) {
        console.log('[orders.getAll] empty with date, retrying without date for OPENED');
        response = await API.get(`/stores/${storeId}/orders?status=${status}`)
        data = response.data;
      }
  let array;
  if (Array.isArray(data)) array = data;
  else if (data && Array.isArray(data.items)) array = data.items;
  else if (data && Array.isArray(data.results)) array = data.results;
  else if (data && Array.isArray(data.data)) array = data.data;
  else array = [];
  console.log('[orders.getAll] normalized count', array.length);
  return array;
    } catch (err) {
      console.error('[orders.getAll] Error:', err);
      throw new Error(err)
    }
  }
  
  const saveOrder = async (storeId, data) => {
    try {
      var response = await API.post(`/stores/${storeId}/orders`, data)
      return response.data;
    } catch (err) {
      console.error('Error:', err);
      throw new Error(err)
    }
  }
  
  const searchOrders = async (storeId, query) => {
    try {
      var response = await API.get(`/stores/${storeId}/orders?`+ query)
      return response.data;
    } catch (err) {
      console.error('Error:', err);
      throw new Error(err)
    }
  }

  const getDashboard = async (storeId, filters = {}) => {
    try {
      const path = withQuery(`/stores/${storeId}/orders/dashboard`, filters);
      const response = await API.get(path);
      return response.data || { group_by: filters?.group_by || 'client', groups: [] };
    } catch (err) {
      console.error('[orders.getDashboard] Error:', err);
      throw new Error(err?.response?.data?.message || err?.message || 'Error al cargar dashboard de pedidos');
    }
  }
  
  const updateLines = async (storeId, orderId, data) => {
    try {
      const response = await API.patch(`/stores/${storeId}/orders/${orderId}/lines`, data);
      return response.data;
    } catch (err) {
      console.error('Error:', err);
      throw new Error(err)
    }
  }
  
  export default OrderService;